import { ProductSlide } from './ProductSlide';
import type { ProductSlideshowSlide } from '../product-slideshow.types';

interface ProductSlideshowMobileSectionProps {
  slide: ProductSlideshowSlide;
  isProductRight: boolean;
}

export function ProductSlideshowMobileSection({ slide, isProductRight }: ProductSlideshowMobileSectionProps) {
  return (
    <div
      className={`flex items-center justify-center md:hidden w-full max-w-105 ${
        isProductRight ? 'md:order-3' : 'order-1'
      }`}
    >
      <div className="relative w-full">
        <ProductSlide {...slide} />
      </div>
    </div>
  );
}
